import { render, staticRenderFns } from "./DateListInput.vue?vue&type=template&id=54150c7c&"
import script from "./DateListInput.vue?vue&type=script&lang=js&"
export * from "./DateListInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports